import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";


@Injectable({
  providedIn: "root",
})
export class HostUrlService {
  static url: string;
  url = environment.apiUrl;
  //url = "http://98.82.170.37:3000";

  constructor() { }
}
